import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {LANGUAGE_STORAGE_KEY} from '../i18n';

export type LanguageCode = 'al' | 'en';

interface UseLanguageResult {
    language: LanguageCode;
    setLanguage: (language: LanguageCode) => void;
}

/**
 * Wraps i18next's language switching so the choice is persisted to
 * localStorage (mirrors i18n.js's getInitialLanguage fallback) and survives
 * a refresh/reopen of the app.
 */
export function useLanguage(): UseLanguageResult {
    const {i18n} = useTranslation();

    const setLanguage = useCallback((language: LanguageCode) => {
        i18n.changeLanguage(language);
        try {
            localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
        } catch {
            // localStorage unavailable (e.g. private browsing) — selection just won't persist.
        }
    }, [i18n]);

    return {
        language: (i18n.language === 'en' ? 'en' : 'al'),
        setLanguage,
    };
}
